// POG Spirits cocktail collection — gallery + shareable recipe pages
// baseKey: vodka | rtd | both · difficulty: Easy | Intermediate

export const COCKTAILS = [
  {
    slug: "kailua-sunset",
    name: "The Kailua Sunset",
    tagline: "The signature serve. Golden hour in a rocks glass.",
    base: "POG Vodka",
    baseKey: "vodka",
    difficulty: "Easy",
    occasion: "Golden Hour",
    glass: "Rocks · Large Cube",
    timeMinutes: 3,
    image: "/products/pog-can.jpg",
    description:
      "A refreshing rocks-style cocktail built with POG Vodka, fresh lime, and orgeat, topped with soda and a burnt orange peel. The pour that started it all.",
    ingredients: [
      "2 oz POG Vodka",
      "¾ oz fresh lime juice",
      "½ oz orgeat",
      "Soda water to top",
      "Burnt orange peel, to garnish",
    ],
    steps: [
      "Build POG Vodka, lime juice and orgeat over a large ice cube in a rocks glass.",
      "Stir gently and top with soda water.",
      "Express a burnt orange peel over the glass and drop it in. Serve at golden hour.",
    ],
    garnish: "Burnt orange peel",
  },
  {
    slug: "lei-day-spritz",
    name: "Lei Day Spritz",
    tagline: "Sparkling, floral, and built for celebration.",
    base: "POG Vodka",
    baseKey: "vodka",
    difficulty: "Easy",
    occasion: "Celebration",
    glass: "Wine Glass · Crushed Ice",
    timeMinutes: 2,
    image: "/products/pog-vodka.jpg",
    description:
      "A sparkling POG Vodka spritz with passion fruit cordial and guava nectar over crushed ice — finished with an edible orchid.",
    ingredients: [
      "1½ oz POG Vodka",
      "3 oz dry sparkling wine",
      "¾ oz passion fruit cordial",
      "Splash of guava nectar",
      "Edible orchid, to garnish",
    ],
    steps: [
      "Build all liquids over crushed ice in a chilled wine glass.",
      "Stir once to combine.",
      "Garnish with an edible orchid and half a passion fruit.",
    ],
    garnish: "Edible orchid + passion fruit half",
  },
  {
    slug: "big-island-punch",
    name: "Big Island Punch",
    tagline: "A tiki-style punch with volcanic depth.",
    base: "Both",
    baseKey: "both",
    difficulty: "Intermediate",
    occasion: "Tiki Night",
    glass: "Tiki Mug · Pebble Ice",
    timeMinutes: 4,
    image: "/products/pog-can.jpg",
    description:
      "A tiki-style punch built on a can of POG Spiked Island Punch with a shot of POG Vodka and Angostura bitters, crowned with a mint bouquet.",
    ingredients: [
      "1 can POG Spiked Island Punch, chilled",
      "1 oz POG Vodka",
      "½ oz fresh lime juice",
      "3 dashes Angostura bitters",
      "Mint bouquet, to garnish",
    ],
    steps: [
      "Fill a tiki mug with pebble ice.",
      "Add POG Vodka, lime juice and Angostura bitters.",
      "Top with the chilled POG Spiked Island Punch, stir once, and garnish with a mint bouquet.",
    ],
    garnish: "Mint bouquet",
  },
  {
    slug: "meadow-gold-mule",
    name: "Meadow Gold Mule",
    tagline: "A Hawai‘i mule — ginger snap meets guava silk.",
    base: "POG Vodka",
    baseKey: "vodka",
    difficulty: "Easy",
    occasion: "Pau Hana",
    glass: "Copper Mug · Cubed Ice",
    timeMinutes: 2,
    image: "/products/pog-vodka.jpg",
    description:
      "The island answer to the classic mule: POG Vodka, fiery ginger beer, and a ribbon of guava nectar. Built for pau hana — the Hawaiian happy hour.",
    ingredients: [
      "2 oz POG Vodka",
      "4 oz ginger beer",
      "½ oz fresh lime juice",
      "¼ oz guava nectar",
      "Lime wheel and candied ginger, to garnish",
    ],
    steps: [
      "Fill a copper mug with cubed ice.",
      "Add POG Vodka, lime juice and guava nectar.",
      "Top with ginger beer, give it one gentle lift with a bar spoon, and garnish.",
    ],
    garnish: "Lime wheel + candied ginger",
  },
  {
    slug: "liliha-gimlet",
    name: "Liliha Gimlet",
    tagline: "Bone-cold, citrus-bright, unapologetically simple.",
    base: "POG Vodka",
    baseKey: "vodka",
    difficulty: "Intermediate",
    occasion: "Golden Hour",
    glass: "Coupe · No Ice",
    timeMinutes: 3,
    image: "/products/pog-vodka.jpg",
    description:
      "A shaken, ice-cold gimlet that lets POG Vodka's passion fruit and orange peel shine — sharpened with lime cordial and a dash of orange bitters.",
    ingredients: [
      "2½ oz POG Vodka",
      "¾ oz lime cordial",
      "2 dashes orange bitters",
      "Expressed orange coin, to garnish",
    ],
    steps: [
      "Add all ingredients to a shaker filled with ice.",
      "Shake hard for 10 seconds until the tin frosts.",
      "Double-strain into a chilled coupe and garnish with an expressed orange coin.",
    ],
    garnish: "Expressed orange coin",
  },
  {
    slug: "peles-punch-bowl",
    name: "Pele's Punch Bowl",
    tagline: "The shareable centrepiece — serve the whole lānai.",
    base: "POG Spiked Island Punch",
    baseKey: "rtd",
    difficulty: "Easy",
    occasion: "Celebration",
    glass: "Punch Bowl · Block Ice",
    timeMinutes: 5,
    image: "/products/pog-can.jpg",
    description:
      "A party-scale punch bowl: four cans of POG Spiked Island Punch lengthened with passion fruit juice and soda over a block of ice. Serves six.",
    ingredients: [
      "4 cans POG Spiked Island Punch, chilled",
      "8 oz passion fruit juice",
      "8 oz soda water",
      "1 oz fresh lime juice",
      "Orange wheels, guava slices and edible flowers, to garnish",
    ],
    steps: [
      "Place a large block of ice in a punch bowl.",
      "Pour in the POG Spiked Island Punch, passion fruit juice and lime juice.",
      "Top with soda, stir once, and float the garnish. Ladle into small cups.",
    ],
    garnish: "Orange wheels + guava slices + edible flowers",
  },
];

export const getCocktail = (slug) => COCKTAILS.find((c) => c.slug === slug);

export const COCKTAIL_FILTERS = {
  base: [
    { key: "all", label: "All bases" },
    { key: "vodka", label: "POG Vodka" },
    { key: "rtd", label: "Spiked Punch" },
    { key: "both", label: "Both" },
  ],
  difficulty: [
    { key: "all", label: "Any level" },
    { key: "Easy", label: "Easy" },
    { key: "Intermediate", label: "Intermediate" },
  ],
  occasion: [
    { key: "all", label: "Any occasion" },
    { key: "Golden Hour", label: "Golden Hour" },
    { key: "Celebration", label: "Celebration" },
    { key: "Pau Hana", label: "Pau Hana" },
    { key: "Tiki Night", label: "Tiki Night" },
  ],
};
